import { createSheetTabParam } from '@repo/ui/components/molecules/sheet-tabs';

/**
 * Schede del dettaglio (Previxio DS · sheet `sepa`): Riepilogo e Dettagli
 * tecnici. La scheda viaggia sull'URL (`?tab=`), così un link o un reload
 * riaprono la stessa; senza parametro è il Riepilogo.
 */
export const PAYMENT_DETAIL_TABS = ['summary', 'technical'] as const;

export type PaymentDetailTab = (typeof PAYMENT_DETAIL_TABS)[number];

export const PAYMENT_DETAIL_TAB_PARAM = createSheetTabParam(
  PAYMENT_DETAIL_TABS,
  'summary'
);

/** Il parametro della search che porta la scheda (già nello schema comune). */
export const PAYMENT_DETAIL_TAB_SEARCH_KEY = 'tab';

/** Parametri del dettaglio, tolti tornando alla lista. */
export const PAYMENT_DETAIL_SEARCH_KEYS = [
  PAYMENT_DETAIL_TAB_SEARCH_KEY,
] as const;

export const PAYMENT_DETAIL_TAB_LABEL_KEYS: Record<PaymentDetailTab, string> = {
  summary: 'acubePayments.detail.tabs.summary',
  technical: 'acubePayments.detail.tabs.technical',
};
